// MENU ICONS
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined"
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined"
// import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined"

import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined"
import DeleteIcon from "@mui/icons-material/Delete"
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined"
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined"
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined"
import logoME from "../../images/me.png"

import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck"
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts"
import NotificationsIcon from "@mui/icons-material/Notifications"
import PhonelinkIcon from "@mui/icons-material/Phonelink"
import LockOpenIcon from "@mui/icons-material/LockOpen"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
//import EmailIcon from "@mui/icons-material/Email"
import CorporateFareIcon from "@mui/icons-material/CorporateFare"
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"
import consultorIA from "../../images/consultor-ai.png"
import fondoErrepar from "../../images/Iso Errepar.png"
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined"
import AppsIcon from "@mui/icons-material/Apps"

export const menuItems = [
  {
    icon: <HomeOutlinedIcon style={{ fontSize: 22, color: "#00a78f" }} />,
    label: "Inicio",
    type: "home",
    href: "home",
    subItems: [],
    roles: [
      "CGI.Admin",
      "CGI.CustomerSupport",
      "CGI.CommercialAgent",
      "CGI.ContentManagementRW",
      "CGI.LegalCommOperator",
      "CGI.MeAppMaintainer",
      "CGI.GlobalNotificationAdmin",
      "CGI.GlobalNotificationInfoOperator",
      "CGI.GlobalNotificationReader",
    ],
  },

  {
    icon: <BusinessOutlinedIcon style={{ fontSize: 21, color: "#00a78f" }} />,
    label: "Organizaciones",
    type: "organizations",
    href: "organizations",
    subItems: [],
    roles: [
      "CGI.Admin",
      "CGI.CustomerSupport",
      "CGI.CommercialAgent",
      "CGI.ContentManagementRW",
      "CGI.LegalCommOperator",
      "CGI.MeAppMaintainer",
      "CGI.GlobalNotificationAdmin",
      "CGI.GlobalNotificationInfoOperator",
      "CGI.GlobalNotificationReader",
    ],
  },

  {
    icon: (
      <PeopleOutlineOutlinedIcon style={{ fontSize: 21, color: "#00a78f" }} />
    ),
    label: "Suscriptores",
    type: "subscribers",
    href: "subscribers",
    subItems: [],
    roles: [
      "CGI.Admin",
      "CGI.CustomerSupport",
      "CGI.CommercialAgent",
      "CGI.ContentManagementRW",
      "CGI.LegalCommOperator",
      "CGI.MeAppMaintainer",
      "CGI.GlobalNotificationAdmin",
      "CGI.GlobalNotificationInfoOperator",
      "CGI.GlobalNotificationReader",
    ],
  },
  {
    icon: <PersonOutlineIcon style={{ fontSize: 21, color: "#00a78f" }} />,
    label: "Usuarios",
    type: "users",
    href: "users",
    subItems: [],
    roles: [
      "CGI.Admin",
      "CGI.CustomerSupport",
      "CGI.CommercialAgent",
      "CGI.ContentManagementRW",
      "CGI.LegalCommOperator",
      "CGI.MeAppMaintainer",
      "CGI.GlobalNotificationAdmin",
      "CGI.GlobalNotificationInfoOperator",
      "CGI.GlobalNotificationReader",
    ],
  },
  {
    icon: (
      <img
        src={logoME}
        style={{ width: "16px", height: "16px", paddingLeft: "2px" }}
      ></img>
    ),
    label: "Mi Estudio",
    type: "ME",
    href: "ME",
    subItems: [
      {
        icon: <ManageAccountsIcon style={{ color: "#4B4952" }} />,
        label: "Administrador de instancias",
        type: "applicationInstances",
        href: "ME/applicationInstances",
        roles: ["CGI.Admin", "CGI.CustomerSupport"],
      },
      {
        icon: (
          <PlaylistAddCheckIcon style={{ color: "#4B4952", fontSize: 21 }} />
        ),
        label: "Habilitación de modulos",
        type: "import-cvs",
        href: "ME/import-cvs",
        roles: ["CGI.Admin", "CGI.CustomerSupport"],
      },
      {
        icon: (
          <PhonelinkIcon
            style={{
              color: "#4B4952",
              fontSize: 21,
            }}
          />
        ),
        label: "Control de versiones",
        type: "feacture-flags",
        href: "ME/feacture-flags",
        roles: ["CGI.Admin", "CGI.MeAppMaintainer"],
      },
      {
        icon: (
          <GroupsOutlinedIcon
            style={{
              color: "#4B4952",
              fontSize: 21,
            }}
          />
        ),
        label: "Clientes",
        type: "clientes",
        href: "ME/clientes",
        roles: ["CGI.Admin", "CGI.CustomerSupport", "CGI.LegalCommOperator"],
      },
      {
        icon: (
          <ReceiptLongIcon
            style={{
              color: "#4B4952",
              fontSize: 21,
            }}
          />
        ),
        label: "Declaraciones",
        type: "declarations",
        href: "ME/declarations",
        roles: ["CGI.Admin", "CGI.CustomerSupport"],
      },
      {
        icon: (
          <EmailOutlinedIcon
            style={{
              color: "#4B4952",
              fontSize: 21,
            }}
          />
        ),
        label: "e-Ventanilla",
        type: "eventanilla",
        href: "ME/eventanilla",
        subItems: [
          {
            icon: (
              <AccountBalanceIcon
                style={{
                  color: "#4B4952",
                  fontSize: 21,
                }}
              />
            ),
            label: "CUITs aceptados en ARCA",
            type: "loadedClients",
            href: "ME/eventanilla/loadedClients",
            roles: [
              "CGI.Admin",
              "CGI.CustomerSupport",
              "CGI.LegalCommOperator",
            ],
          },
          {
            icon: (
              <CorporateFareIcon
                style={{
                  color: "#4B4952",
                  fontSize: 21,
                }}
              />
            ),
            label: "Clientes Asociados",
            type: "eventanilla",
            href: "ME/eventanilla",
            roles: [
              "CGI.Admin",
              "CGI.CustomerSupport",
              "CGI.LegalCommOperator",
            ],
          },
        ],
        roles: ["CGI.Admin", "CGI.CustomerSupport", "CGI.LegalCommOperator"],
      },
    ],
    roles: [
      "CGI.Admin",
      "CGI.CustomerSupport",
      "CGI.CommercialAgent",
      "CGI.ContentManagementRW",
      "CGI.LegalCommOperator",
      "CGI.MeAppMaintainer",
      "CGI.GlobalNotificationAdmin",
      "CGI.GlobalNotificationInfoOperator",
      "CGI.GlobalNotificationReader",
    ],
  },

  {
    icon: <SecurityOutlinedIcon style={{ fontSize: 21, color: "#00a78f" }} />,
    label: "Sistema y Seguridad",
    type: "security",
    href: "",
    subItems: [
      {
        icon: (
          <InsertDriveFileOutlinedIcon
            style={{ fontSize: 21, color: "#4B4952" }}
          />
        ),
        label: "Administración de extensiones",
        type: "file-extension",
        href: "security/file-extension",
        roles: [
          "CGI.Admin",
          "CGI.CustomerSupport",
          "CGI.CommercialAgent",
          "CGI.ContentManagementRW",
          "CGI.LegalCommOperator",
          "CGI.MeAppMaintainer",
        ],
      },
      {
        icon: (
          <AdminPanelSettingsOutlinedIcon
            style={{ fontSize: 21, color: "#4B4952" }}
          />
        ),
        label: "Administración en cognito",
        type: "cognito",
        href: "security/cognito",
        roles: [
          "CGI.Admin",
          "CGI.CustomerSupport",
          "CGI.CommercialAgent",
          "CGI.ContentManagementRW",
          "CGI.LegalCommOperator",
          "CGI.MeAppMaintainer",
        ],
      },
      {
        icon: <LockOpenIcon style={{ fontSize: 21, color: "#4B4952" }} />,
        label: "Administración de sesiones",
        type: "user-sessions",
        href: "security/user-sessions",
        roles: [
          "CGI.Admin",
          "CGI.CustomerSupport",
          "CGI.CommercialAgent",
          "CGI.ContentManagementRW",
          "CGI.LegalCommOperator",
          "CGI.MeAppMaintainer",
        ],
      },
    ],
    roles: [
      "CGI.Admin",
      "CGI.CustomerSupport",
      "CGI.CommercialAgent",
      "CGI.ContentManagementRW",
      "CGI.LegalCommOperator",
      "CGI.MeAppMaintainer",
      "CGI.GlobalNotificationAdmin",
      "CGI.GlobalNotificationInfoOperator",
      "CGI.GlobalNotificationReader",
    ],
  },
  {
    icon: <DnsOutlinedIcon style={{ fontSize: 21, color: "#00a78f" }} />,
    label: "Almacenamiento",
    type: "storage",
    href: "",
    roles: [
      "CGI.Admin",
      "CGI.CustomerSupport",
      "CGI.CommercialAgent",
      "CGI.ContentManagementRW",
      "CGI.LegalCommOperator",
      "CGI.MeAppMaintainer",
      "CGI.GlobalNotificationAdmin",
      "CGI.GlobalNotificationInfoOperator",
      "CGI.GlobalNotificationReader",
    ],
    subItems: [
      {
        icon: <DeleteIcon style={{ color: "#4B4952" }} />,
        label: "Papelera",
        type: "recycle",
        href: "storage/recycle",
        roles: [
          "CGI.Admin",
          "CGI.CustomerSupport",
          "CGI.CommercialAgent",
          "CGI.ContentManagementRW",
          "CGI.LegalCommOperator",
          "CGI.MeAppMaintainer",
          "CGI.GlobalNotificationAdmin",
          "CGI.GlobalNotificationInfoOperator",
          "CGI.GlobalNotificationReader",
        ],
      },
    ],
  },
  {
    icon: <AppsIcon style={{ fontSize: 21, color: "#00a78f" }} />,
    label: "Acceso a aplicaciones",
    type: "admin-access-user-app-content",
    href: "admin-access-user-app-content",
    roles: [
      "CGI.Admin",
      "CGI.GlobalAppAccessAdmin",
      "CGI.GlobalAppMaintainer",
      "CGI.CgiAppAccessAdmin",
      "CGI.MeAppAccessAdmin",
      "CGI.CmAppAccessAdmin",
      "CGI.PerAppAccessAdmin",
    ],
    subItems: [
      {
        icon: (
          <img
            src={consultorIA}
            style={{ width: "16px", height: "16px", paddingLeft: "2px" }}
          ></img>
        ),
        label: "PER",
        type: "applicationPER",
        href: "admin-access-user-app-content/applicationPER",
        roles: [
          "CGI.Admin",
          "CGI.GlobalAppAccessAdmin",
          "CGI.PerAppAccessAdmin",
          "CGI.GlobalAppMaintainer",
        ],
      },
      {
        icon: (
          <img
            src={fondoErrepar}
            style={{ width: "16px", height: "16px", paddingLeft: "2px" }}
          ></img>
        ),
        label: "CGI",
        type: "applicationCGI",
        href: "admin-access-user-app-content/applicationCGI",
        roles: [
          "CGI.Admin",
          "CGI.CgiAppAccessAdmin",
          "CGI.GlobalAppAccessAdmin",
          "CGI.GlobalAppMaintainer",
        ],
      },
      {
        icon: (
          <img
            src={fondoErrepar}
            style={{ width: "16px", height: "16px", paddingLeft: "2px" }}
          ></img>
        ),
        label: "CM",
        type: "applicationCM",
        href: "admin-access-user-app-content/applicationCM",
        roles: [
          "CGI.Admin",
          "CGI.CmAppAccessAdmin",
          "CGI.GlobalAppAccessAdmin",
          "CGI.GlobalAppMaintainer",
        ],
      },
    ],
  },
  {
    icon: <NotificationsIcon style={{ fontSize: 21, color: "#00a78f" }} />,
    label: "Notificaciones globales",
    type: "globalNotification",
    href: "globalNotification",
    subItems: [],
    roles: [
      "CGI.Admin",
      "CGI.GlobalNotificationAdmin",
      "CGI.GlobalNotificationInfoOperator",
      "CGI.GlobalNotificationReader",
    ],
  },

  // {
  //   icon: <AppsOutlinedIcon style={{ fontSize: 21, color: '#00a78f' }} />,
  //   label: 'Apariencia',
  //   type: 'appearance',
  //   href: 'appearance',
  //   subItems: []
  // },
]
